import { faTag } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/design-system/Pill";
import { Tooltip } from "src/design-system/Tooltip";

type Props = {
  version: string;
  dataLoc: string;
};

export const ManifestVersionPill: React.FC<Props> = ({ version, dataLoc }) => (
  <Tooltip title="Manifest version" asChild>
    <Pill dataLoc={dataLoc} size="sm" variant="gray">
      <Pill.Icon icon={faTag} />
      <Pill.Text>v{version}</Pill.Text>
    </Pill>
  </Tooltip>
);
